import Blue from "~/dfwjobs/core";

new Blue({
	name: 'CTA Updates',
	selector: ".updates-cta__content",
	setup(container) {
        const blueComponent = container.closest("blue-component");
		blueComponent.style.marginTop = "auto";
	}
});